import { Grid } from "@mui/material";
import React, { useState } from "react";
import { constants } from "../../../common/constants/constants";
import { ToastNotification } from "../../../common/components/toastNotification/ToastNotification";
import errorToast from "../../../assets/images/errorToast.svg";
import successToast from "../../../assets/images/successToast.svg";

import BuyerCredentialForm from "./buyerCredentialForm/buyerCredentialForm";
import BuyerCartForm from "./buyerCartForm/buyerCartForm";
import { AddBulkCartProvider } from "./context/AddBulkCartProvider";

function AddBulkCart() {
  const [toastData, setToastData] = useState(constants.defaultToastData);

  return (
    <AddBulkCartProvider>
      {toastData?.message && (
        <ToastNotification
          icon={toastData.status === "Success" ? successToast : errorToast}
          content={toastData?.message}
          position={"top-right"}
          autoClose={2000}
          handleClose={() => setToastData(constants.defaultToastData)}
        />
      )}
      <Grid style={{ padding: "20px 20px" }}>
        <BuyerCredentialForm />
        <BuyerCartForm />
      </Grid>
    </AddBulkCartProvider>
  );
}

export default AddBulkCart;
